import { Capacitor } from '@capacitor/core';
import { NativeBiometric } from 'capacitor-native-biometric';

interface FaceIDResult {
  success: boolean;
  error?: string;
}

class FaceIDService {
  private isInitialized: boolean = false;

  constructor() {
    this.initialize();
  }

  private initialize() {
    try {
      
      
      
      
      if (Capacitor.isNativePlatform()) {
        // Set initialized to true immediately since the Capacitor plugin doesn't require waiting
        this.isInitialized = true;
        
      } else {
        
        // For web preview, we can set to true to enable UI testing
        this.isInitialized = true;
      }
    } catch (error) {
      
      this.isInitialized = false;
    }
  }
  
  private mockAuthenticationForWeb(message: string): Promise<FaceIDResult> {
    // This is for testing only - simulates biometric authentication on web
    
    return new Promise((resolve) => {
      if (window.confirm('Biometric Authentication Simulation: ' + message)) {
        
        resolve({ success: true });
      } else {
        
        resolve({ success: false, error: 'User canceled' });
      }
    });
  }

  public isConfigured(): boolean {
    // Check if Face ID has been configured in this app
    const savedEmail = localStorage.getItem('faceIDEmail');
    
    
    if (!savedEmail) return false;
    
    // Also verify the password is stored
    const passwordKey = `faceID_pwd_${savedEmail}`;
    const hasPassword = !!localStorage.getItem(passwordKey);
    return hasPassword;
  }
  
  // Helper method to mask email for logs
  private hashEmail(email: string): string {
    if (!email) return 'none';
    const parts = email.split('@');
    if (parts.length !== 2) return 'invalid-email';
    
    const username = parts[0];
    const domain = parts[1];
    
    // Show first 2 chars of username + *** + @ + domain
    return `${username.substring(0, 2)}***@${domain}`;
  }

  public async isAvailable(): Promise<boolean> {
    if (!this.isInitialized) {
      this.initialize();
      // Wait for initialization with a short timeout
      await new Promise(resolve => setTimeout(resolve, 200));
    }
    
    // On web, we can simulate availability for testing
    if (!Capacitor.isNativePlatform()) {
      
      return false;
    }
    
    try {
      const result = await NativeBiometric.isAvailable();
      
      
      // Check if the device supports biometrics
      return result.isAvailable;
    } catch (error) {
      
      return false;
    }
  }

  public async authenticate(message: string = "Giriş yapmak için biyometrik doğrulama kullanın"): Promise<FaceIDResult> {
    if (!this.isInitialized) {
      this.initialize();
    }
    
    // For web, create a simulated experience
    if (!Capacitor.isNativePlatform()) {
      
      return this.mockAuthenticationForWeb(message);
    }
    
    try {
      const result = await NativeBiometric.verifyIdentity({
        reason: message,
        title: "Biyometrik Doğrulama",
        subtitle: "Kimliğinizi doğrulamak için",
        description: "Devam etmek için biyometrik kimlik doğrulaması kullanın"
      });
      
      
      return { success: true };
    } catch (error) {
      
      return { 
        success: false, 
        error: typeof error === 'string' ? error : error.message || 'Authentication failed'
      };
    }
  }

  public clearStoredCredentials(): void {
    const savedEmail = localStorage.getItem('faceIDEmail');
    if (savedEmail) {
      localStorage.removeItem('faceIDEmail');
      const passwordKey = `faceID_pwd_${savedEmail}`;
      localStorage.removeItem(passwordKey);
      
    }
  }

  public isFaceIDSupported(): boolean {
    // We'll do a real check for biometric support
    return Capacitor.isNativePlatform();
  }
}

// Export as singleton
export default new FaceIDService(); 